import React, { FC } from 'react';

import { Container } from 'layout';

import { useElasticContext } from '../../../contexts/elasticContext';
import { CustomResultsAndPresentationHitsProps } from './models';
import ResultsAndPresentationItem from './ResultsAndPresentationItem';

import './CustomResultsAndPresentationHits.scss';

const CustomResultsAndPresentationHits: FC<CustomResultsAndPresentationHitsProps> = ({
  lang,
  loadMoreText,
  viewPageLinkText,
  pressReleaseLinkText,
}) => {
  const { dataHits, loadMore, handleLoadMoreHits } = useElasticContext();

  return (
    <div className="results-and-presentation">
      <Container>
        <ul className="results-and-presentation__list">
          {dataHits?.map((hit) => (
            <li className="results-and-presentation__item" key={hit.id}>
              <ResultsAndPresentationItem
                hit={hit}
                lang={lang}
                viewPageLinkText={viewPageLinkText}
                pressReleaseLinkText={pressReleaseLinkText}
              />
            </li>
          ))}
        </ul>
        <button
          type="button"
          className="results-and-presentation-more-btn btn btn--primary btn--pink"
          onClick={() => handleLoadMoreHits()}
          disabled={!loadMore}
        >
          {loadMoreText}
        </button>
      </Container>
    </div>
  );
};

export default CustomResultsAndPresentationHits;
